import React from 'react';
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Separator } from "@/components/ui/separator"
import {useAuthentication} from "../contexts/AuthenticationContext";

export function AccountDropdown() {
    const { logout, user } = useAuthentication();

    const handleLogout = async () => {
        await logout();
    };

    return (
        <Card className="w-80 shadow-lg">
            <CardContent className="p-4">
                <div className="space-y-4">
                    <div>
                        <h3 className="text-lg font-semibold">{user?.role}</h3>
                        <p className="text-sm text-gray-500">{user?.email}</p>
                    </div>
                    <Separator />
                    <Button
                        variant="ghost"
                        className="w-full justify-start p-0 h-auto font-normal text-base"
                        onClick={handleLogout}
                    >
                        Logout
                    </Button>
                </div>
            </CardContent>
        </Card>
    )
}
